import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Grid,
	Tooltip,
	Typography,
	Box,
	useTheme,
	Divider,
} from "@mui/material";
import useStyles from "./styles";
import GrupoChip from "../../grupoEconomico/GrupoChip";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import { BusinessOutlined } from "@mui/icons-material";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import WifiOutlinedIcon from "@mui/icons-material/WifiOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
// Novos ícones para os dados técnicos
import RouterOutlinedIcon from "@mui/icons-material/RouterOutlined";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import PhonelinkSetupOutlinedIcon from "@mui/icons-material/PhonelinkSetupOutlined";

export default function AccordionVero(params) {
	const {
		id,
		nome,
		status,
		setSnackbar,
		dataCadastroContrato,
		dataFimContrato,
		dataInicioContrato,
		formaPagamento,
		diaVencimento,
		categoria,
		permiteAlterarWifi,
		enderecoCompleto,
		data,
		valor,
		ownerNome,
	} = params;

	const theme = useTheme();
	const styles = useStyles(theme);

	// Pegando o primeiro item do array de dados técnicos (se existir)
	const dadosTecnicos = data && data.length > 0 ? data[0] : null;

	// Ajuste as regras de status de acordo com o padrão de retorno da Vero
	const waitingReturn = ["Pré-cadastro", "Aguardando"];
	const enabledService = ["ATIVO"];

	function formatarMoedaBR(input) {
		if (input == null || input === "") return "R$ 0,00";

		if (typeof input === "number") {
			input = Math.round(input * 100).toString();
		}

		let digits = input.toString().replace(/\D/g, "");

		while (digits.length < 3) digits = "0" + digits;

		const cents = digits.slice(-2);
		let integerPart = digits.slice(0, -2);

		integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

		return `R$ ${integerPart},${cents}`;
	}

	async function CopyTexto({ campo }) {
		if (!campo || campo === "-") return;
		try {
			await navigator.clipboard.writeText(campo);
		} catch (err) {
			const textArea = document.createElement("textarea");
			textArea.value = campo;
			document.body.appendChild(textArea);
			textArea.select();
			try {
				document.execCommand("copy");
			} catch (err) {
				console.error("Falha ao copiar texto: ", err);
			}
			document.body.removeChild(textArea);
		}
		setSnackbar({
			children: "Campo copiado!",
			severity: "info",
		});
	}

	return (
		<Accordion variant="outlined" elevation={0}>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
				aria-controls={`panel-${id}-content`}
				id={`panel-${id}-header`}
				sx={styles.accordionSummary}
			>
				<Grid container spacing={1} alignItems="center">
					<Grid item xs={12} sm={8}>
						<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
							<Tooltip title={nome || "Cliente sem nome"}>
								<Typography
									variant="subtitle1"
									fontWeight="bold"
									sx={styles.summaryTextOverflow}
								>
									{`${id || "S/N"} - ${nome || "Cliente não identificado"}`}
								</Typography>
							</Tooltip>
							{ownerNome && <GrupoChip label={ownerNome} variant="owner" />}
						</Box>
					</Grid>
					<Grid item xs={12} sm={4} sx={styles.accordionTextStatus}>
						<Box
							sx={{
								...styles.statusDot,
								...(waitingReturn.includes(status)
									? {
										bgcolor: theme.palette.colors.orange.light,
										animation: "pulse 1.5s infinite",
										boxShadow: `0 0 10px ${theme.palette.colors.orange.light}`,
									}
									: enabledService.includes(status)
										? {
											bgcolor: theme.palette.colors.green.light,
										}
										: {
											bgcolor: theme.palette.colors.red.light,
										}),
							}}
						/>
						<Tooltip title={status || "Indefinido"}>
							<Typography
								variant="body2"
								color="text.secondary"
								sx={styles.summaryTextOverflow}
							>
								{status || "Status não informado"}
							</Typography>
						</Tooltip>
					</Grid>
				</Grid>
			</AccordionSummary>
			<Divider />
			<AccordionDetails sx={{ paddingBottom: 1 }}>
				{" "}
				<Grid container spacing={1.5} alignItems={"flex-start"}>
					{" "}
					{/* COLUNA 1 - Dados Cadastrais e Endereço */}
					<Grid item xs={12} sm={8}>
						<Grid container spacing={0.5}>
							{" "}
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<BusinessOutlined sx={styles.icons} />
									<Typography sx={styles.boxEnderecoTitle}>
										Endereço:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.boxEnderecoContent}
											onClick={() => CopyTexto({ campo: enderecoCompleto })}
										>
											{enderecoCompleto || "Endereço não informado"}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<CalendarMonthOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>Valor:</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() =>
												CopyTexto({ campo: formatarMoedaBR(valor) })
											}
										>
											{formatarMoedaBR(valor)}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<CalendarMonthOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Data de Início:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() => CopyTexto({ campo: dataInicioContrato })}
										>
											{dataInicioContrato}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<CalendarMonthOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Data de Cancelamento:
									</Typography>
									{status === "CANCELADO" && (
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() => CopyTexto({ campo: dataFimContrato })}
											>
												{dataFimContrato}
											</Typography>
										</Tooltip>
									)}
								</Box>
							</Grid>
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<CalendarMonthOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Data de Cadastro:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() => CopyTexto({ campo: dataCadastroContrato })}
										>
											{dataCadastroContrato}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
						</Grid>
					</Grid>
					{/* COLUNA 2 - Financeiro e Produto */}
					<Grid item xs={12} sm={4}>
						<Grid container spacing={0.5} alignItems={"flex-start"}>
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<CategoryOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Categoria:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() => CopyTexto({ campo: categoria })}
										>
											{categoria || "-"}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>

							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<CreditCardOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Forma de Pagamento:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() => CopyTexto({ campo: formaPagamento })}
										>
											{formaPagamento || "-"}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>

							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<MonetizationOnOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Vencimento:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() => CopyTexto({ campo: diaVencimento })}
										>
											{diaVencimento ? `Dia ${diaVencimento}` : "-"}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>

							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<WifiOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Altera Wi-Fi:
									</Typography>
									<Typography sx={styles.typographyLabel}>
										{permiteAlterarWifi ? "Sim" : "Não"}
									</Typography>
								</Box>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				{/* DADOS TÉCNICOS EXTRAÍDOS DO DATA[] */}
				{dadosTecnicos && (
					<Box
						sx={{
							mt: 1.5,
							pt: 1.5,
							borderTop: `1px solid ${theme.palette.divider}`,
						}}
					>
						<Typography
							variant="subtitle2"
							color="text.secondary"
							fontWeight="bold"
							sx={{ mb: 1 }}
						>
							Dados Técnicos e Autenticação
						</Typography>
						<Grid container spacing={1}>
							{/* Produto */}
							{dadosTecnicos.NOM_PROD && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<RouterOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											Produto:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: dadosTecnicos.NOM_PROD })
												}
											>
												{dadosTecnicos.COD_PROD} - {dadosTecnicos.NOM_PROD}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
							{/* COD_POLICY */}
							{dadosTecnicos.COD_POLICY && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<AssignmentOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											Política:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: dadosTecnicos.COD_POLICY })
												}
											>
												{dadosTecnicos.COD_POLICY}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
							{/* STATUS TÉCNICO */}
							{dadosTecnicos.DES_STATUS && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<AssignmentOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											Status Técnico:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: dadosTecnicos.DES_STATUS })
												}
											>
												{dadosTecnicos.DES_STATUS}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
							{/* DESIGNACAO_TECNICA */}
							{dadosTecnicos.DESIGNACAO_TECNICA && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<AssignmentOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											Designação:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: dadosTecnicos.DESIGNACAO_TECNICA })
												}
											>
												{dadosTecnicos.DESIGNACAO_TECNICA}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
							{/* REFERENCIA_CLIENTE */}
							{dadosTecnicos.REFERENCIA_CLIENTE && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<AssignmentOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											Referência CLI:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: dadosTecnicos.REFERENCIA_CLIENTE })
												}
											>
												{dadosTecnicos.REFERENCIA_CLIENTE}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
							{/* COD_PROTOCOLO */}
							{dadosTecnicos.COD_PROTOCOLO && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<AssignmentOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											Protocolo:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: dadosTecnicos.COD_PROTOCOLO })
												}
											>
												{dadosTecnicos.COD_PROTOCOLO}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}

							{/* === IPs E REDE === */}
							{/* IP Designado */}
							{dadosTecnicos.LISTA_IP && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<DnsOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											IP Designado:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: dadosTecnicos.LISTA_IP })
												}
											>
												{dadosTecnicos.LISTA_IP}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
							{/* IP POP */}
							{dadosTecnicos.NUM_IP_POP && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<DnsOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											IP POP:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: dadosTecnicos.NUM_IP_POP })
												}
											>
												{dadosTecnicos.NUM_IP_POP}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
							{/* Slot / PON */}
							{(dadosTecnicos.NUM_SLOT || dadosTecnicos.NUM_PON) && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<DnsOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											Slot / PON:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({
														campo: `${dadosTecnicos.NUM_SLOT} / ${dadosTecnicos.NUM_PON}`,
													})
												}
											>
												{dadosTecnicos.NUM_SLOT} / {dadosTecnicos.NUM_PON}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}

							{/* === CREDENCIAIS === */}
							{/* PPPoE Usuário */}
							{dadosTecnicos.USUR_PPPOE && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<VpnKeyOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											Usuário PPPoE:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: dadosTecnicos.USUR_PPPOE })
												}
											>
												{dadosTecnicos.USUR_PPPOE}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
							{/* PPPoE Senha */}
							{dadosTecnicos.SEN_PPPOE && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<VpnKeyOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											Senha PPPoE:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: dadosTecnicos.SEN_PPPOE })
												}
											>
												{dadosTecnicos.SEN_PPPOE}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
							{/* Usuário App */}
							{dadosTecnicos.USUR_APP && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<PhonelinkSetupOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											Usuário App:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: dadosTecnicos.USUR_APP })
												}
											>
												{dadosTecnicos.USUR_APP}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
							{/* Senha App */}
							{dadosTecnicos.SEN_APP && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<PhonelinkSetupOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											Senha App:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: dadosTecnicos.SEN_APP })
												}
											>
												{dadosTecnicos.SEN_APP}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}

							{/* === WI-FI === */}
							{/* Wi-Fi SSID */}
							{dadosTecnicos.NOM_WIFI && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<WifiOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											Nome Wi-Fi:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: dadosTecnicos.NOM_WIFI })
												}
											>
												{dadosTecnicos.NOM_WIFI}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
							{/* Senha Wi-Fi */}
							{dadosTecnicos.SEN_WIFI && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<WifiOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											Senha Wi-Fi:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: dadosTecnicos.SEN_WIFI })
												}
											>
												{dadosTecnicos.SEN_WIFI}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}

							{/* === HARDWARE MACs === */}
							{/* MAC Address */}
							{dadosTecnicos.COD_MAC_ADDRESS && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<RouterOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											MAC/Serial:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: dadosTecnicos.COD_MAC_ADDRESS })
												}
											>
												{dadosTecnicos.COD_MAC_ADDRESS}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
							{/* MAC Serial Number */}
							{dadosTecnicos.COD_MAC_ADDRESS_SERIALNUMBER && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<RouterOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											SN MAC:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({
														campo: dadosTecnicos.COD_MAC_ADDRESS_SERIALNUMBER,
													})
												}
											>
												{dadosTecnicos.COD_MAC_ADDRESS_SERIALNUMBER}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
							{/* MAC ATA */}
							{dadosTecnicos.COD_MAC_ADDRESS_ATA && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<RouterOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											MAC ATA:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({
														campo: dadosTecnicos.COD_MAC_ADDRESS_ATA,
													})
												}
											>
												{dadosTecnicos.COD_MAC_ADDRESS_ATA}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
							{/* MAC Roteador */}
							{dadosTecnicos.COD_MAC_ADDRESS_ROTEADOR && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<RouterOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											MAC Roteador:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({
														campo: dadosTecnicos.COD_MAC_ADDRESS_ROTEADOR,
													})
												}
											>
												{dadosTecnicos.COD_MAC_ADDRESS_ROTEADOR}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
							{/* SN Roteador */}
							{dadosTecnicos.COD_MAC_ADDRESS_ROTEADOR_SERIALNUMBER && (
								<Grid item xs={12} sm={6} md={4}>
									<Box sx={styles.boxCampos}>
										<RouterOutlinedIcon sx={styles.icons} />
										<Typography sx={styles.typhographyTitle}>
											SN Roteador:
										</Typography>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({
														campo:
															dadosTecnicos.COD_MAC_ADDRESS_ROTEADOR_SERIALNUMBER,
													})
												}
											>
												{dadosTecnicos.COD_MAC_ADDRESS_ROTEADOR_SERIALNUMBER}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							)}
						</Grid>
					</Box>
				)}
			</AccordionDetails>
		</Accordion>
	);
}
